import React, { useState, useEffect } from "react";
import "./BlogCard.css";
import { useNavigate } from "react-router-dom";

function readingTime(text) {
  const words = text.trim().split(/\s+/).length;
  return { minutes: Math.max(1, Math.round(words / 200)) };
}

export default function BlogCard({ blog }) {
  const [lables, setLables] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getLabels();
  }, []);

  function openBlog(title, number) {
    navigate(`/blog/${title}/${number}`);
  }

  function getLabels() {
    const lables = blog.labels.nodes.filter((value, index) => {
      return value.name !== "blog";
    });
    setLables(lables);
  }
  return (
    <div className="blog-card-div">
      <div className="blog-card-header">
        <div>
          {lables.map(value => {
            return (
              <div key={value.id} className="blog-catgeory" style={{ backgroundColor: `#${value.color}` }}>
                {value.name}
              </div>
            );
          })}
        </div>
        <div>
          <p className="reading-time">{readingTime(blog.body).minutes} Min Read</p>
        </div>
      </div>
      <div>
        <div className="blog-card-title">
          <h2 onClick={() => openBlog(blog.title, blog.number)}>{blog.title}</h2>
        </div>
        <div className="blog-card-description">
          <p>
            {blog.bodyText}
          </p>
        </div>
        <div className="blog-card-footer"></div>
      </div>
    </div>
  );
}
